export default __webpack_public_path__ + "static/media/arrow-up-white.21ca93b5.svg";